import React from 'react';
import Subtopics from './Subtopics';
import { Container } from "react-bootstrap";
import {
    Switch,
    Route,
    Link,
    useRouteMatch
  } from "react-router-dom";

function LinearAlgebra(props) {
    let { path, url } = useRouteMatch();
    return (
        <div>
            <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', maxWidth: "100vw"}}>
                {/* <SectionTitle title={props.topicId}/> */}
            <div style={{display: 'flex', flexDirection: 'row'}}> 
            <div style={{marginTop: '10px', marginRight: '0px', marginLeft: '5px',border: '3px', padding:'40px', paddingRight: '50px', borderStyle:'solid', borderColor:'grey', paddingLeft: '20px', whiteSpace:'nowrap'}}>
                <h2>Linear Algebra</h2>
                <li>
                    <Link to={`${url}/vectorspaces`}>Vector Spaces</Link>
                </li>
                <li>
                    <Link to={`${url}/matrixoperations`}>Matrix Operations</Link>
                </li>
                <li>
                    <Link to={`${url}/systemsoflinearequations`}>Systems of Linear Equations</Link>
                </li>       
                 <li>
                    <Link to={`${url}/lineartransformations`}>Linear Transformations</Link>
                </li>        
                  <li>
                    <Link to={`${url}/eigenvalues`}>Eigenvalues</Link>
                </li>     
                   <li>
                    <Link to={`${url}/matrixdecomposition`}>Matrix Decomposition</Link>
                </li>     
                    <li>
                    <Link to={`${url}/tensormathematics`}>Tensor Mathematics</Link>
                </li>   
                    <li>
                    <Link to={`${url}/numericallinearalgebra`}>Numerical Linear Algebra</Link>
                </li>   
                </div>
                
            <Container>
                <Switch>
                    <Route exact path={path}>
                    <h3>Please select a sub-topic.</h3>
                    </Route>
                    <Route path={`${path}/:topicId`}>
                        <Subtopics />
                    </Route>
                </Switch>
            </Container>
         
                    </div>
            </div>
        </div>
    );
};

export default LinearAlgebra; 